import { useState } from 'react';
import { CustomMarker } from '../components/map/IMapProvider';

interface Location {
  lat: number;
  lng: number;
}

interface UseMapInteractionProps {
  setLocation: (location: Location) => void;
}

export const useMapInteraction = ({ setLocation }: UseMapInteractionProps) => {
  const [customMarkers, setCustomMarkers] = useState<CustomMarker[]>([]);

  const handleMapClick = (lat: number, lng: number) => {
    // Always use the same ID to update the existing marker's position
    const marker: CustomMarker = {
      id: 'user-custom-marker',
      lat,
      lng,
      name: 'Custom Location',
    };
    // This will either add the first marker or update its position
    setCustomMarkers([marker]);
  };

  const handleMapRightClick = (lat: number, lng: number) => {
    // Right click moves the search center (user location)
    setLocation({ lat, lng });
  };

  return {
    customMarkers,
    handleMapClick,
    handleMapRightClick,
  };
};